var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tile",
    { staticClass: "notes", attrs: { link: "comments" } },
    [
      _c(
        "tile-title",
        {
          staticClass: "notes__title",
          attrs: { slot: "tileHeader", icon: "pencil" },
          slot: "tileHeader",
        },
        [_vm._v("Заметки")]
      ),
      _vm._v(" "),
      _vm.auth
        ? [
            _vm.list.length > 0
              ? _c(
                  "ul",
                  {
                    staticClass: "notes__list",
                    attrs: { slot: "tileContent" },
                    slot: "tileContent",
                  },
                  _vm._l(_vm.list, function (n, i) {
                    return _c("note-item", {
                      key: i,
                      attrs: {
                        isMyNote:
                          _vm.login.toLowerCase() == n.user_login.toLowerCase(),
                        note: n,
                      },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.list.length === 0
              ? _c(
                  "p",
                  {
                    staticClass: "empty-message",
                    attrs: { slot: "tileContent" },
                    slot: "tileContent",
                  },
                  [_vm._v("Заметки о контрагенте не найдены.")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("note-send", {
              attrs: { slot: "tileFooter" },
              slot: "tileFooter",
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.auth
        ? _c(
            "demo-message",
            { attrs: { slot: "tileContent" }, slot: "tileContent" },
            [_vm._v("\n        В демо-режиме заметки не отображаются\n    ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }